import React, { useState } from 'react';
import { formatTimestamp } from '../../utils/dateUtils';

export default function CommentItem({ comment, onDelete, currentUserId }) {
    const [isDeleting, setIsDeleting] = useState(false);
    const isSystem = comment.isSystemMessage;
    const canDelete = !isSystem && currentUserId === comment.userId;
    
    const handleDelete = async () => {
        if (!window.confirm('האם אתה בטוח שברצונך למחוק הערה זו?')) {
            return;
        }
        
        setIsDeleting(true);
        try {
            await onDelete(comment.id);
        } catch (error) {
            console.error('Error deleting comment:', error);
            alert('שגיאה במחיקת ההערה');
            setIsDeleting(false);
        }
    };
    
    return (
        <div style={{
            padding: '10px',
            marginBottom: '8px',
            backgroundColor: isSystem ? '#F0F8FF' : '#FFFFFF',
            borderRadius: '8px',
            border: isSystem ? '1px solid #B0D4F1' : '1px solid #E0E0E0',
            direction: 'rtl',
            position: 'relative'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '6px',
                gap: '8px'
            }}>
                <span style={{ fontSize: '16px' }}>
                    {isSystem ? '🤖' : '👤'}
                </span>
                <span style={{
                    fontWeight: '600',
                    fontSize: '14px',
                    color: isSystem ? '#1976D2' : '#333'
                }}>
                    {comment.userName}
                </span>
                <span style={{
                    fontSize: '12px',
                    color: '#999',
                    marginRight: 'auto'
                }}>
                    {formatTimestamp(comment.timestamp)}
                </span>
                {canDelete && (
                    <button
                        onClick={handleDelete}
                        disabled={isDeleting}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#999',
                            cursor: isDeleting ? 'not-allowed' : 'pointer',
                            fontSize: '16px',
                            padding: '4px 8px',
                            opacity: isDeleting ? 0.5 : 1,
                            transition: 'color 0.2s'
                        }}
                        onMouseEnter={(e) => !isDeleting && (e.currentTarget.style.color = '#f44336')}
                        onMouseLeave={(e) => !isDeleting && (e.currentTarget.style.color = '#999')}
                        title="מחק הערה"
                    >
                        🗑️
                    </button>
                )}
            </div>
            <div style={{
                fontSize: '14px',
                color: isSystem ? '#555' : '#333',
                lineHeight: '1.4',
                paddingRight: '24px',
                fontStyle: isSystem ? 'italic' : 'normal'
            }}>
                {comment.text}
            </div>
        </div>
    );
}